import { forwardRef, useContext } from "react";
import { InputTypes } from "../../data-parsing/InputTypes";
import { InputField } from "./InputField";
import { OptionsSources } from "../../data-parsing/OptionsSources";
import { LegendContext } from "../../context/legend";
import { useCollection } from "../../hooks";
import {
  MultivaluedInputPopUp,
  MultivaluedInputPopUpArray,
} from "./MultivaluedInputPopUp";
import { findVal, getKeyByValue } from "../../data-parsing/parseUtils";
import { data } from "jquery";

export const InputWrapper = forwardRef((props, ref) => {
  const { metadata, type, defaultValue, setValue, name, ...childProps } = props;
  /*const {legend} = useContext(LegendContext);
    const cachedData = useCollection(metadata?.optionsMapping?.collection);
    let newProps = {...props};

    function buildSelectOptions(name, optionsMapping) {
        let options;
        switch (optionsMapping?.source) {
            case OptionsSources.LEGEND:
                options = Object.entries({...legend[name]})?.map(([key, value]) => {
                    return {value: key, label: value?.ES};
                })
                break;
            case OptionsSources.COLLECTION:
                let propertyName = getKeyByValue(optionsMapping?.collection, optionsMapping?.property);
                let visiblePropertyName = getKeyByValue(optionsMapping?.collection, optionsMapping?.visibleProperty);
                if (!visiblePropertyName) {
                    visiblePropertyName = propertyName;
                }
                options = cachedData?.filter(optionsMapping?.filter).map((dataElement) => {
                    return {
                        value: dataElement[propertyName],
                        label: findVal(dataElement, visiblePropertyName)
                    }
                })
                break;
            case OptionsSources.BOOLEAN:
                options = [{value: true, label: "Sí"}, {value: false, label: "No"}];
                break;
            case OptionsSources.INLINE:
                options = optionsMapping?.options;
                break;
            default:
                options = [];
                break;
        }
        return options;
    }*/

  switch (type) {
    case InputTypes.ARRAY:
      return <ArrayInputWrapper ref={ref} {...props} />;

    case InputTypes.POPUP_ARRAY:
      return <PopupArrayInputWrapper ref={ref} {...props} />;

    case InputTypes.COMPOSED:
      return Object.keys(metadata?.composedElements).map((key, i) => {
        return (
          <div key={i} style={{ flexGrow: "1" }} className={"m-r-10"}>
            <InputWrapper
              key={`${key}${i}`}
              name={key}
              ref={ref}
              metadata={metadata?.composedElements[key]}
              type={metadata?.composedElements[key]?.type}
              defaultValue={defaultValue && defaultValue[key]}
              {...childProps}
            />
          </div>
        );
      });
    case InputTypes.MULTIPLE_SELECT:
    case InputTypes.SELECT:
      return <SelectInputWrapper ref={ref} {...props} />;
    case InputTypes.SELECT_WITH_PLACEHOLDER:
      return <SelectInputWrapper ref={ref} {...props} />;
    //newProps.options = buildSelectOptions(name, metadata?.optionsMapping);
    default:
      return <DefaultInputWrapper ref={ref} {...props} />;
    /*const {compact, showLabel, ...rest} = newProps;
            const {optionsMapping: a, visibleName, ...newMetadata} = metadata;
            delete rest.metadata;
            return showLabel ? <div className={"form-control-wrapper" + (compact ? " compact" : "")}>
                    <label>{visibleName}</label>
                    <InputField ref={ref} {...{...rest, ...newMetadata}} />
                </div>
                : <InputField ref={ref} {...{...rest, ...newMetadata}} />*/
  }
});

const DefaultInputWrapper = forwardRef((props, ref) => {
  const { compact, showLabel, metadata, ...rest } = props;
  const { visibleName, ...newMetadata } = metadata;


  if (props.type === InputTypes.DATE)
    console.log("DefaultInputwrapper passed value? ", props)


  //delete rest.metadata;
  return showLabel ? (
    <div className={"form-control-wrapper" + (compact ? " compact" : "")}>
      <label>{visibleName}</label>
      <InputField ref={ref} {...{ ...rest, ...newMetadata }} />
    </div>
  ) : (
    <InputField ref={ref} value={props?.value} {...{ ...rest, ...newMetadata }} />
  );
});

const SelectInputWrapper = forwardRef((props, ref) => {
  const { metadata, type, defaultValue, setValue, name } = props;
  const { legend } = useContext(LegendContext);
  const cachedData = useCollection(metadata?.optionsMapping?.collection);
  let newProps = { ...props };
  newProps.options = buildSelectOptions(name, metadata?.optionsMapping);
  delete newProps.optionsMapping;

  function buildSelectOptions(name, optionsMapping) {
    let options;
    switch (optionsMapping?.source) {
      case OptionsSources.LEGEND:
        options = Object.entries({ ...legend[name] })?.map(([key, value]) => {
          return { value: key, label: value?.ES };
        });
        break;
      case OptionsSources.COLLECTION:
        let propertyName = getKeyByValue(
          optionsMapping?.collection,
          optionsMapping?.property
        );
        let visiblePropertyName = getKeyByValue(
          optionsMapping?.collection,
          optionsMapping?.visibleProperty
        );
        if (!visiblePropertyName) {
          visiblePropertyName = propertyName;
        }
        options = cachedData
          ?.filter(optionsMapping?.filter)
          .map((dataElement) => {
            return {
              value: dataElement[propertyName],
              label: findVal(dataElement, visiblePropertyName),
            };
          });
        break;
      case OptionsSources.BOOLEAN:
        options = [
          { value: true, label: "Sí" },
          { value: false, label: "No" },
        ];
        break;
      case OptionsSources.INLINE:
        options = optionsMapping?.options;
        break;
      default:
        options = [];
        break;
    }
    return options;
  }

  return <DefaultInputWrapper {...newProps} />;
});

const ArrayInputWrapper = forwardRef((props, ref) => {
  const { metadata, type, defaultValue, setValue, name } = props;
  let preview = metadata?.array?.composedElements[metadata?.array?.preview];
  return (
    <div style={{ display: "relative" }}>
      <MultivaluedInputPopUp
        metadata={metadata?.array}
        name={name}
        data={defaultValue}
        setData={setValue}
        additionalFields={metadata?.array?.additionalElements}
        trigger={
          <button
            ref={ref}
            name={props.name}
            style={{ float: "right" }}
            data-toggle="tooltip"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <i className="fa fa-external-link"></i>
          </button>
        }
      ></MultivaluedInputPopUp>

      {defaultValue[metadata?.array?.name]?.map((e, i) => {
        return (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "stretch",
              marginRight: "35px",
            }}
          >
            <InputWrapper
              ref={ref}
              type={preview?.type}
              metadata={preview}
              defaultValue={e && e[metadata?.array?.preview]}
              stringified={true}
            />
          </div>
        );
      })}
    </div>
  );
});

const PopupArrayInputWrapper = forwardRef((props, ref) => {
  const { metadata, type, defaultValue, setValue, name } = props;
  let preview = metadata?.array?.preview;

  /*   console.log("defaultValue", defaultValue);
  console.log("preview", preview);
  console.log("defaultValue[preview]", defaultValue[preview]); */

  const previewValues = Array.isArray(defaultValue)
    ? defaultValue.map((item) => item[preview]).filter(Boolean)
    : [];

  /*   console.log("previewVAlues", previewValues);
   */
  return (
    <div style={{ display: "relative" }}>
      <MultivaluedInputPopUpArray
        metadata={metadata?.array}
        name={name}
        data={defaultValue}
        setData={setValue}
        additionalFields={metadata?.array?.additionalElements}
        trigger={
          <button
            ref={ref}
            name={props.name}
            style={{ float: "right" }}
            data-toggle="tooltip"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <i className="fa fa-external-link"></i>
          </button>
        }
      />

      {previewValues.length > 0 ? (
        previewValues.map((e, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "stretch",
              marginRight: "35px",
            }}
          >
            <InputWrapper
              ref={ref}
              type={preview?.type}
              metadata={preview}
              defaultValue={e}
              stringified={true}
            />
          </div>
        ))
      ) : (
        <div>No hay información.</div>
      )}
    </div>
  );
});
